import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setAssignDriver } from "../../../redux/reducer/transport.reducer";

import ContentCard from "../../../components/misc/ContentCard";
import Text from "../../../styleguide/Text";
import SelectableItem from "../../../components/misc/SelectableItem/SelectableItem";

import AssignDriverIntranod from "./AssignDriverIntranod";
import AssignDriverRoute from "./AssignDriverRoute";
import AssignDriverComposed from "./AssignDriverComposed";

const types = ["local", "intranod", "compusa"] as const;

function AssignDriver() {
  const dispatch = useAppDispatch();
  const [routeType, setRouteType] = useState<"local" | "intranod" | "compusa">(
    "local",
  );

  const {
    transport: { assignedDriverData },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  useEffect(() => {
    if (assignedDriverData) {
      let routeTypeConst: "local" | "intranod" | "compusa" = "local";
      if (assignedDriverData.id_ruta_intranod && assignedDriverData.id_ruta) {
        routeTypeConst = "compusa";
      } else if (assignedDriverData.id_ruta_intranod) {
        routeTypeConst = "intranod";
      }
      setRouteType(routeTypeConst);
    }
  }, [assignedDriverData]);

  useEffect(() => {
    return () => {
      dispatch(setAssignDriver(null));
    };
  }, [dispatch]);

  return (
    <ContentCard
      CardHeader={() => (
        <div className="d-flex align-items-center justify-content-between w-100">
          <Text variant="h1" className="mb-5">
            Asignare ruta
          </Text>
          {!assignedDriverData && (
            <div className="d-flex align-items-center">
              {types.map((type) => (
                <SelectableItem
                  key={type}
                  value={type}
                  name="routeType"
                  title={type.charAt(0).toUpperCase() + type.slice(1)}
                  className="px-5"
                  onClick={({ value }) => {
                    value &&
                      setRouteType(value as "local" | "intranod" | "compusa");
                  }}
                  checked={routeType === type}
                  type="radio"
                />
              ))}
            </div>
          )}
        </div>
      )}>
      {routeType === "local" && <AssignDriverRoute />}
      {routeType === "intranod" && <AssignDriverIntranod />}
      {routeType === "compusa" && <AssignDriverComposed />}
    </ContentCard>
  );
}

export default AssignDriver;
